"use strict";

exports.__esModule = true;
var _DeviceColorSourcePicker = require("./DeviceColorSourcePicker");
Object.keys(_DeviceColorSourcePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceColorSourcePicker[key]) return;
  exports[key] = _DeviceColorSourcePicker[key];
});
var _DeviceCycleColorSource = require("./DeviceCycleColorSource");
Object.keys(_DeviceCycleColorSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceCycleColorSource[key]) return;
  exports[key] = _DeviceCycleColorSource[key];
});
var _DeviceMetricColorSource = require("./DeviceMetricColorSource");
Object.keys(_DeviceMetricColorSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMetricColorSource[key]) return;
  exports[key] = _DeviceMetricColorSource[key];
});
var _DeviceColorBox = require("./DeviceColorBox");
Object.keys(_DeviceColorBox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceColorBox[key]) return;
  exports[key] = _DeviceColorBox[key];
});
var _DeviceColorController = require("./DeviceColorController");
Object.keys(_DeviceColorController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceColorController[key]) return;
  exports[key] = _DeviceColorController[key];
});
var _DeviceTimelineColorController = require("./DeviceTimelineColorController");
Object.keys(_DeviceTimelineColorController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTimelineColorController[key]) return;
  exports[key] = _DeviceTimelineColorController[key];
});
var _DeviceColorSource = require("./DeviceColorSource");
Object.keys(_DeviceColorSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceColorSource[key]) return;
  exports[key] = _DeviceColorSource[key];
});
var _DeviceValueColorSource = require("./DeviceValueColorSource");
Object.keys(_DeviceValueColorSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceValueColorSource[key]) return;
  exports[key] = _DeviceValueColorSource[key];
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});